import React from "react"
import PropTypes from "prop-types"

import api from "@api"
import getInput from "../Form/helpers/getInput"
import ListInput from "./ListInput"
import { TYPE_HIDDEN } from "../FormItem/types"
import getComponentInputs from "../Form/helpers/getComponentInputs"

const operation = api.get("backstage/CreateProject")

/* td: pull from enum */
/* td: rename to LINK */
const ASSET_TYPE = "EMBEDED_VIDEO"
const ASSET_COMPONENT_PATH = "#/definitions/Asset"

const LABEL_TITLE = "Title"
const LABEL_URL = "URL"


const LinksListInput = ({
  form,
  name,
  path,
  title,
  addTitle,
  urlPlaceholder,
  namePlaceholder,
  linkValidationRules
}) => {
  const schema = getComponentInputs(getInput, operation.id, ASSET_COMPONENT_PATH, [
    {
      name: "name",
      placeholder: namePlaceholder,
      inputProps: {rows: 1},
      itemProps: { noStyle: true }
    },
    {
      name: "url",
      placeholder: urlPlaceholder,
      itemProps: {
        rules: linkValidationRules,
        noStyle: true
      }
    }, {
      name: "description",
      type: TYPE_HIDDEN,
    }, {
      type: TYPE_HIDDEN,
      name: "type",
      initialValue: ASSET_TYPE
    }, {
      type: TYPE_HIDDEN,
      name: "isPublic",
      /* td: use default value on BE */
      initialValue: true,
    }, {
      type: TYPE_HIDDEN,
      name: "path",
      /* td: make not required on BE */
      initialValue: "NA",
    }
  ])

  return (
    <ListInput
      form={form}
      name={name}
      path={path}
      title={title}
      schema={schema}
      addTitle={addTitle}
      className="horizontal-oriented"
    />
  )
}

LinksListInput.propTypes = {
  form: PropTypes.shape().isRequired,
  name: PropTypes.arrayOf(PropTypes.string).isRequired,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  /* note: custom component props */
  title: PropTypes.string.isRequired,
  addTitle: PropTypes.string.isRequired,
  urlPlaceholder: PropTypes.string,
  namePlaceholder: PropTypes.string,
  linkValidationRules: PropTypes.arrayOf(PropTypes.shape({})),
}

LinksListInput.defaultProps = {
  urlPlaceholder: LABEL_URL,
  namePlaceholder: LABEL_TITLE,
  linkValidationRules: [],
}

export default LinksListInput
